import { BaseNavigation } from '~/services/navigation/baseNavigation'
import { TranslationService } from '~/services/Translation'

export class AuthNavigation extends BaseNavigation {
	static toLogin(leadId?: string): void {
		const locale = TranslationService.getInstance().getLocale()
		let route = `/${locale}/auth/login`
		if (leadId) route += `?lead_id=${leadId}&utm_channel=lead`
		this.navigateTo(route)
	}

	static toSignup(utmChannel?: string): void {
		const locale = TranslationService.getInstance().getLocale()
		let route = `/${locale}/auth/signup`
		if (utmChannel) route += `?utm_channel=${utmChannel}`
		this.navigateTo(route)
	}
}
